import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import Button from "../../../shared/components/atoms/button/button"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import RecommenderQuestion from "../../atoms/recommender-question/recommender-question"
import "./recommender.scss"

const Recommender = ({ test, slug }) => {
  const [numberQuestion, setPageLoad] = useState(0)
  const [answersTest, setAnswersTest] = useState([])
  const [currentAnwser, setCurrentAnwser] = useState(null)
  const [activeAnswerTest, setActiveAnswerTest] = useState(false)
  const [productsFilter, setProductsFilter] = useState([])

  const resultQuery = useStaticQuery(
    graphql`
      query QUERY_PRODUCTS {
        allContentfulNolProductos {
          nodes {
            titulo
            node_locale
            imagenDelProducto {
              file {
                url
              }
              description
            }
            tipoDeToallaprotector
            tipoDePiel
            tipoDeActividad
            ropaInterior
            movimiento
            flujoPlus
            flujo
            aplicador
            caracteristica
            paisesDeRestriccionDelProducto
            referenciaSubcategoria {
              referenciaCategoria {
                slug
              }
            }
          }
        }
      }
    `
  )
  const getRestrictedProducts = () => {
    let tempItems = []
    resultQuery.allContentfulNolProductos.nodes
      .filter(e => e.node_locale === process.env.LOCALE && e.titulo !== null)
      .filter(e => e.referenciaSubcategoria?.referenciaCategoria.slug === slug)
      .map(item => {
        if (
          item.paisesDeRestriccionDelProducto === null ||
          !item.paisesDeRestriccionDelProducto.includes(
            process.env.LOCALE.split("-")[1]
          )
        ) {
          tempItems.push(item)
        }
        return null
      })
    return tempItems
  }

  const [products] = useState(getRestrictedProducts())
  const [forceClass, setforceClass] = useState("f-Recommender")

  useEffect(() => {
    let answersAux = answersTest
    for (let i = 0; i < test.length; i++) {
      answersAux.push(0)
    }
    setAnswersTest(answersAux)
    setforceClass("f-Recommender")
  }, [])

  const userInfoEncrypt= encryptUserInfo()
  const handleNextFilter = () => {
    pushDataLayerEvent({
      event: "Interacciones - Asesoría",
      category: "recomendador",
      action: "click",
      label: currentAnwser.repuesta,
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })

    let next = numberQuestion + 1
    if (test.length <= next) {
      let productsFilter = products
      for (let i = 0; i < test.length; i++) {
        productsFilter = productsFilter.filter(item =>
          item[test[i].tipoDePregunta]
            ? item[test[i].tipoDePregunta] ===
              test[i].referenciaRespuestas[answersTest[i]].tipoDeRespuesta
            : true
        )
      }
      setProductsFilter(productsFilter)
      setActiveAnswerTest(true)
      pushDataLayerEvent({
        event: "Interacciones - Asesoría",
        category: "recomendador",
        action: "view",
        label: "Estos son tus productos ideales",
        location: window.location.href,
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      })
    } else {
      setPageLoad(next)
    }
  }
  const handlePrevFilter = () => {
    pushDataLayerEvent({
      event: "Interacciones - Asesoría",
      category: "recomendador",
      action: "click",
      label: "Anterior",
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })

    let next = numberQuestion - 1
    setPageLoad(next)
  }
  const handleChangeAnswer = (question, answer) => {
    let answersAux = answersTest
    answersAux[question] = answer
    setCurrentAnwser(test[question]?.referenciaRespuestas[answer] || null)
    setAnswersTest({ ...answersAux })
  }
  const handleResetTest = () => {
    pushDataLayerEvent({
      event: "Interacciones - Asesoría",
      category: "recomendador",
      action: "click",
      label: "Quiero otra recomendación",
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
    
    setActiveAnswerTest(false)
    setPageLoad(0)
    let answersAux = []
    for (let i = 0; i < test.length; i++) {
      answersAux.push(0)
    }
    setAnswersTest(answersAux)
  }

  return (
    <>
      <div className={"f-recommender " + forceClass}>
        <div className="f-recommender-content">
          <h2 className="f-recommender__title">
            ¿Sabes cuál es tu producto ideal?
          </h2>
          <div className="f-recommender-content-whitebox">
            {test && !activeAnswerTest && (
              <RecommenderQuestion
                handleChangeAnswer={handleChangeAnswer}
                answersTest={answersTest}
                numberQuestion={numberQuestion}
                questions={test}
                handleNextFilter={handleNextFilter}
                handlePrevFilter={handlePrevFilter}
              />
            )}
            {activeAnswerTest && (
              <div>
                <h3 className="f-recommender-content__title">
                  Estos son tus productos ideales
                </h3>
                <div className="f-recommender-content-whitebox-content">
                  <div className="f-recommender-content-whitebox-content-products">
                    {productsFilter.map((product, index) => {
                      if (index < 4) {
                        return (
                          <div
                            key={index}
                            className="f-recommender-content-answer"
                          >
                            <div className="f-recommender-content-answer-img">
                              <img
                                className="f-img-stamp"
                                src={product.imagenDelProducto.file.url}
                                alt={product.imagenDelProducto.description}
                              />
                            </div>
                            <p>{product.titulo}</p>
                          </div>
                        )
                      } else {
                        return null
                      }
                    })}
                  </div>
                  <Button
                    className="new-primary-pink short"
                    title="Quiero otra recomendación"
                    onClick={handleResetTest}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Recommender
